// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fJ","catalogByServiceItem__title":"c-k_fK"};